import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import api from "../client"
import { AddressDetailResponseData } from "../types/address"

const getData = async (uuid: string | undefined) => {
  try {
    const { data } = await api.get(`/address/${uuid}`)
    return data
  } catch ({ response: { data } }) {
    return data
  }
}

export const useAddress = (uuid: string | undefined):
  QueryObserverBaseResult<AddressDetailResponseData> => {
  const { data, ...props } = useQuery<AddressDetailResponseData>(
    queryKeys.ADDRESS(uuid),
    () => getData(uuid),
    { enabled: !!uuid }
  )
  return { data, ...props }
}
